export const ACCOUNT_STORAGE_KEY = 'neuro_repetitor';
export const INFO_STUDY_WORD_STORAGE_KEY = 'info_study_word';
export const IS_SHOW_ASSESSMENT = 'is_show_assessment';
